module.exports = __webpack_public_path__ + "static/media/energetic_slightly-sad.db784f82.svg";